import { FC } from "react";
import { WatchlistRowProps } from "./types";

export const WatchlistRow: FC<WatchlistRowProps> = ({
  watchlist,
  isSelected,
  onSelect,
}) => {
  const isDisabled = watchlist.wlData?.length === 50;


  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!isDisabled && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      onSelect(watchlist);
    }
  };

  return (
    <button
      type="button"
      className="flex w-full cursor-pointer border-b border-[#e5e5e5] p-3 text-left"
      onClick={() => !isDisabled && onSelect(watchlist)}
      onKeyDown={handleKeyDown}
      disabled={isDisabled}
      tabIndex={isDisabled ? -1 : 0}
      aria-disabled={isDisabled}
    >
      <input
        type="radio"
        name="watchlist-radio-group"
        checked={isSelected}
        onChange={() => !isDisabled && onSelect(watchlist)}
        onClick={(e) => e.stopPropagation()}
        className={`mr-3 cursor-pointer ${isDisabled ? "invisible" : ""}`}
        disabled={isDisabled}
      />
      <div className="flex flex-col items-start">
        <div
          className={`text-sm font-normal ${
            isDisabled ? "text-[#999999]" : "text-[#1A1A1A]"
          }`}
        >
          {watchlist.wlName}
        </div>
        <div
          className={`text-[10px] font-normal ${
            isDisabled ? "text-[#999999]" : "text-[#666666]"
          }`}
        >
          {watchlist.wlData?.length || 0} Stocks
        </div>
      </div>
    </button>
  );
};

export default WatchlistRow;

